// icons
import { Icon } from '@iconify/react';
import Box, { BoxProps } from '@mui/material/Box';
import { IconWeight } from '@phosphor-icons/react';
// @mui
import { forwardRef } from 'react';

//
import { IconifyProps } from './types';

// ----------------------------------------------------------------------
// Renders either a Phosphor component (the convention) or an Iconify name.
//
// Phosphor icons are imported as real components, so a misspelled name is a
// TypeScript error rather than a blank box — no build step or name registry
// needed. `weight` defaults to "light", the house convention.
//
// The Iconify branch exists only for the exceptions documented in
// src/utils/icons.ts (brand marks, the animated spinner, colored emoji,
// letter glyphs). Those names are resolved over the network by @iconify/react.
// ----------------------------------------------------------------------

interface Props extends BoxProps {
  icon: IconifyProps;
  weight?: IconWeight;
}

const Iconify = forwardRef<SVGElement, Props>(({ icon, width = 20, weight = 'light', sx, ...other }, ref) => {
  const dimensions = { width, height: width, ...sx };

  // An Iconify name (string) or an inline IconifyIcon object, which always carries `body`.
  if (typeof icon === 'string' || 'body' in icon) {
    return (
      <Box ref={ref} component={Icon} className="component-iconify" icon={icon as string} sx={dimensions} {...other} />
    );
  }

  return <Box ref={ref} component={icon} weight={weight} className="component-iconify" sx={dimensions} {...other} />;
});

export default Iconify;
